module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-4.299031f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-4.jpg
// module id = DLBp
// module chunks = 1